// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610120945/js/" + chunkId + "." + {"44":"5395c0fd","225":"0e446173","481":"7ea727a4","486":"aa7812d2","770":"9bda6060"}[chunkId] + ".0.6496151374675052.chunk.js";
};